import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../core/navigation/services/navigation.service';
import { CreatePaymentService } from '../../services/create-payment.service';
import { SearchBoxService } from '../../../core/navigation-search/services/search-box.service';
import { NavigationSearchConfigService } from '../../../core/navigation-search/services/navigation-search-config.service';
import {MessagesService} from '../../../message/services/messages.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FedPaymentTypesService} from "../../services/fed-payment-types.service";
import {DialogDataResponse} from "../../../shared/fn-ui-export/models/dialog-data-response.model";
import {QuickActionsService} from "../../../messages-center/services/user-quick-actions/quick-actions.service";
import {QUICK_ACTION_BUTTON_DEFAULT_LIST} from "../../../messages-center/models/consts/quick-action-button.const";
import {UserQuickActionModalLists} from "../../../messages-center/models/user-quick-action-modal-lists.model";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, OnDestroy {

  isCreateMessageTypesEmpty: boolean;
  messagesService = inject(MessagesService);
  isLoading = false;
  private destroy$ = new Subject<void>();
  userQuickActionsModalList: UserQuickActionModalLists;

  constructor(private createPaymentService: CreatePaymentService,
    private router: Router,
    private navigationService: NavigationService,
    private searchBoxService: SearchBoxService,
    private navigationSearchConfigService: NavigationSearchConfigService,
    protected fedPaymentTypeHandlerService: FedPaymentTypesService,
    protected quickActionsService: QuickActionsService) { }

  ngOnInit(): void {
    this.initUserQuickActions();
    this.isCreateMessageTypesEmpty = this.navigationService.getCreatePaymentItems()?.length === 0;
    this.messagesService.isLoading.pipe(takeUntil(this.destroy$)).subscribe(loading => {
      this.isLoading = loading;
      this.fedPaymentTypeHandlerService.initFedMopMediaMap();
    });
  }

  async initUserQuickActions(){
    this.isLoading = true;
    this.userQuickActionsModalList=  await this.quickActionsService.getQuickActionModalLists();
    let selectedUserQuickActions= this.userQuickActionsModalList.selected;
    this.quickActionsService.userActionsList = selectedUserQuickActions;
    let shouldRestoreDefault = selectedUserQuickActions.length>0 && selectedUserQuickActions.length <this.quickActionsService.minColumnSelection;
    if(shouldRestoreDefault){
      this.quickActionsService.restoreDefault().then(()=>{
        this.userQuickActionsModalList.selected=  [...QUICK_ACTION_BUTTON_DEFAULT_LIST]
        this.quickActionsService.userActionsList=[...QUICK_ACTION_BUTTON_DEFAULT_LIST]
        this.isLoading = false
      })
    }else{
      this.isLoading = false
    }
  }
  createPayment() {
    this.createPaymentService.openModal();
  }

  searchAPayment() {
    const messagesSearchBoxItem = this.navigationSearchConfigService.getSearchBoxItem('messages');
    this.searchBoxService.emitSearchBoxItem(messagesSearchBoxItem);
  }

  recentQueuesView() {
    this.router.navigate(['/home/messages-center/recent-searches']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async onChangeQuickActionsClick(){
    const availableList = this.userQuickActionsModalList.available
    const selectedList = this.userQuickActionsModalList.selected;

    this.quickActionsService.openDialog(availableList as any, selectedList as any, false).afterClosed().subscribe(
      (result: DialogDataResponse) => {
        this.quickActionsService.handleQuickActionData(result)?.then(async (selected) => {
          this.userQuickActionsModalList= await this.quickActionsService.getQuickActionModalLists();
        },(error) =>{} );
      });
  }
}
